import { AffiliateCard } from "@/components/AffiliateCard";

export function AffiliatePartnersBlock() {
  return (
    <section
      id="affiliate-partners"
      className="mx-auto max-w-6xl px-6 py-12 lg:px-12"
      aria-labelledby="affiliate-partners-title"
    >
      <div className="rounded-3xl border border-border bg-card p-6 shadow-sm sm:p-10">
        <div className="text-center">
          <h2
            id="affiliate-partners-title"
            className="text-2xl font-bold text-foreground sm:text-3xl"
          >
            Optimisez votre investissement LMNP
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-muted-foreground sm:text-base">
            Nos partenaires de confiance pour aller plus loin.
          </p>
        </div>
        <div className="mt-8 grid gap-5 md:grid-cols-2">
          <AffiliateCard variant="credit" placement="results-footer" />
          <AffiliateCard variant="assurance" placement="results-footer" />
        </div>
      </div>
    </section>
  );
}
